const ScrollMagic = require('ScrollMagic');
require('debug.addIndicators');
import {UserProfile} from './classes';

export default {
    submitPending: false,
    submitted: false,
    showUitleg: false,
    userReady: false,
    userProfile: new UserProfile(),
    mainProfileChange: '', /* Indicates which profile property has changed. Sometimes changing a single property causes other properties to change as well. */
    showProfielForm: false,
    windowHeight: 0,
    scroller: new ScrollMagic.Controller({
        globalSceneOptions: {
            triggerHook: 0
        }
    }),
    jobTypes1: [
      {category: null, label: "Leraar", isTeacher: true, profileText: "Ik werk als leraar."},
      {category: "B", label: "Werkzaam in het onderwijs, maar ik ben geen leraar", isTeacher: false, profileText: "Ik werk in het onderwijs, maar ben geen leraar."},
      {category: "D", label: "Zelfstandige / ondernemer", isTeacher: false, profileText: "Ik werk als zelfstandige/ondernemer."},
      {category: "C", label: "Ambtenaar", isTeacher: false, profileText: "Ik werk als ambtenaar."},
      {category: "D", label: "Werknemer", isTeacher: false, profileText: "Ik werk in loondienst."}
    ],
    jobTypes2: [
      {category:"A", mail: '3A', label: "Met een baan als lerarenopleider", profileText: "met een baan als lerarenopleider"},
      {category:"B", mail: '3B', label: "Met een andere baan in het onderwijs (bijvoorbeeld onderzoeker, onderwijsinnovator)", profileText: "met een andere baan in het onderwijs (bijvoorbeeld, onderzoeker, onderwijsinnovator)"},
      {category:"D", mail: '3C', label: "Met werk als zelfstandige", profileText: "met werk als zelfstandige"},
      {category:"C", mail: '3D', label: "Met een baan als ambtenaar", profileText: "met een baan als ambtenaar"},
      {category:"D", mail: '3E', label: "Met een baan als werknemer", profileText: "met een baan als werknemer"}
    ],
    quotes: require('../../assets/data/quotes.json'),
    vacatureDruk:
        [
            {
                "vak": "Informatiekunde/ICT-vakken",
                "tekort": true,
                "vacaturedruk": "8,8",
                "type": "beta"
            },
            {
                "vak": "Scheikunde",
                "vacaturedruk": "5,3",
                "tekort": true,
                "type": "beta"
            },
            {
                "vak": "Natuurkunde",
                "vacaturedruk": "5,0",
                "tekort": true,
                "type": "beta"
            },
            {
                "vak": "Duits",
                "tekort": true,
                "vacaturedruk": "4,8",
                "type": "alfa"
            },
            {
                "vak": "Klassieke talen/klassieke culturele vorming (KCV)",
                "tekort": true,
                "vacaturedruk": "4,6",
                "type": "alfa"
            },
            {
                "vak": "Frans",
                "tekort": true,
                "vacaturedruk": "3,2",
                "type": "alfa"
            },
            {
                "vak": "Wiskunde",
                "tekort": true,
                "vacaturedruk": "1,8",
                "type": "beta"
            },
            {
                "vak": "Filosofie/wijsbegeerte",
                "vacaturedruk": "1,6",
                "type": "gamma"
            },
            {
                "vak": "Techniek",
                "vacaturedruk": "0,7",
                "type": "beta"
            },
            {
                "vak": "Aardrijkskunde",
                "vacaturedruk": "0,5",
                "type": "gamma"
            },
            {
                "vak": "Biologie",
                "vacaturedruk": "0,4",
                "type": "beta"
            },
            {
                "vak": "Nederlands",
                "tekort": true,
                "vacaturedruk": "0,3",
                "type": "alfa"
            },
            {
                "vak": "Engels",
                "tekort": true,
                "vacaturedruk": "0,2",
                "type": "alfa"
            },
            {
                "vak": "Maatschappijleer/ maatschappijwetenschappen",
                "vacaturedruk": "0,1",
                "type": "gamma"
            },
            {
                "vak": "Economie",
                "vacaturedruk": "0,1",
                "type": "gamma"
            },
            {
                "vak": "Kunst (algemeen) en cultuur(geschiedenis)",
                "vacaturedruk": "0,1",
                "type": "gamma"
            },
            {
                "vak": "Geschiedenis (en staatsinrichting)",
                "vacaturedruk": "0,1",
                "type": "gamma"
            },
            {
                "vak": "Lichamelijke opvoeding",
                "vacaturedruk": "0,1",
                "type": "gamma"
            },
            {
                "vak": "Mentorles",
                "vacaturedruk": "0,0",
                "type": "gamma"
            },
            {
                "vak": "Management en organisatie",
                "vacaturedruk": "0,0",
                "type": "gamma"
            },
            {
                "vak": "Muziek",
                "vacaturedruk": "0,0",
                "type": "overig"
            },
            {
                "vak": "Tekenen",
                "vacaturedruk": "0,0",
                "type": "overig"
            },
            {
                "vak": "CKV",
                "vacaturedruk": "0,0",
                "type": "overig"
            },
            {
                "vak": "Beeldende vorming",
                "vacaturedruk": "0,0",
                "type": "gamma"
            },
            {
                "vak": "Andere vakken[1]",
                "vacaturedruk": "0,0",
                "type": "overig"
            },
            {
                "vak": "Natuurkunde/scheikunde (NASK)",
                "tekort": true,
                "vacaturedruk": "0,0",
                "type": "beta"
            },
            {
                "vak": "Handvaardigheid",
                "vacaturedruk": "0,0",
                "type": "overig"
            },
            {
                "vak": "Natuur, leven en technologie (NLT)",
                "vacaturedruk": "0,0",
                "type": "gamma"
            },
            {
                "vak": "Spaans",
                "vacaturedruk": "0,0",
                "type": "alfa"
            },
            {
                "vak": "O&O (Onderzoek & Ontwerpen)",
                "vacaturedruk": "0,0",
                "type": "beta"
            },
            {
                "vak": "Keuzewerktijd (KWT)",
                "vacaturedruk": "0,0",
                "type": "gamma"
            },
            {
                "vak": "Bewegen, sport en maatschappij (BSM)",
                "vacaturedruk": "0,0",
                "type": "overig"
            },
            {
                "vak": "Rekenen",
                "vacaturedruk": "0,0",
                "type": "beta"
            },
            {
                "vak": "Begeleidingsuren/counselinguren",
                "vacaturedruk": "0,0",
                "type": "gamma"
            },
            {
                "vak": "Drama",
                "vacaturedruk": "0,0",
                "type": "overig"
            }
        ],
    urenVerdeling: require('../../assets/data/constructie.json')
}


// WEBPACK FOOTER //
// ./src/components/application/app-model.js